type Locale = 'en' | 'id';

/** Replace the first path segment with the next locale */
export function withLocale(pathname: string, next: Locale | string) {
  const parts = pathname.split('/');
  if (parts[0] !== '') parts.unshift('');
  if (!['en', 'id'].includes(parts[1] as Locale)) {
    parts.splice(1, 0, next);
  } else {
    parts[1] = next;
  }
  return parts.join('/').replace(/\/{2,}/g, '/');
}